var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7461 20.0033H8.74858C8.05869 20.0033 7.49878 20.5632 7.49878 21.2531C7.49878 21.9442 8.05869 22.5029 8.74858 22.5029H23.7461C24.436 22.5029 24.9959 21.9442 24.9959 21.2531C24.9959 20.5632 24.436 20.0033 23.7461 20.0033V20.0033ZM23.7461 27.502H8.74858C8.05869 27.502 7.49878 28.0607 7.49878 28.7518C7.49878 29.443 8.05869 30.0016 8.74858 30.0016H23.7461C24.436 30.0016 24.9959 29.443 24.9959 28.7518C24.9959 28.0607 24.436 27.502 23.7461 27.502V27.502ZM24.9959 10.0049C23.6162 10.0049 22.4963 8.8851 22.4963 7.50532C22.4963 7.50532 22.4963 5.4819 22.4963 2.50614L29.9951 10.0049H24.9959V10.0049ZM29.9951 35.0008C29.9951 36.3806 28.8753 37.5004 27.4955 37.5004H4.9992C3.61943 37.5004 2.49961 36.3806 2.49961 35.0008V5.00573C2.49961 3.62596 3.61943 2.50614 4.9992 2.50614H19.9618C19.9393 5.4994 19.9967 7.50532 19.9967 7.50532C19.9967 10.2661 22.2351 12.5045 24.9959 12.5045C24.9959 12.5045 27.0843 12.5045 29.9951 12.5045V35.0008V35.0008ZM22.4963 0.00653872V0.041533C22.3363 0.041533 21.669 -0.019707 19.9967 0.00653872H4.99918C2.23838 0.00653872 0 2.24492 0 5.00572V35.0008C0 37.7616 2.23838 40 4.99918 40H27.4955C30.2563 40 32.4947 37.7616 32.4947 35.0008V10.0049L22.4963 0.00653872V0.00653872Z",
    fill: "#131314"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.949f25745bd88fe9dd55b34d634a9d1a.svg";
export { ForwardRef as ReactComponent };